<template lang="html">
    <data-table
        :headers="datatable.headers"
        :endpoint="datatable.endpoint"
        :toolbar="datatable.toolbar"
        :actions="datatable.actions"
        :views="datatable.views"
        @rowClick="rowClick"
        storeId="projects"
        ref="list"
        selectable
    >

        <template slot="items" slot-scope="props">
            <td>
                {{ props.item.label }}
            </td>
            <td v-if="props.item.category && props.item.category.parent && props.item.category.parent.parent" class="text-xs-right">
                    {{ props.item.category.parent.parent.label }}
            </td>
            <td v-else></td>
            <td v-if="props.item.category && props.item.category.parent " class="text-xs-right">
                    {{ props.item.category.parent.label }}
            </td>
            <td v-else></td>
            <td v-if="props.item.category" class="text-xs-right">
                    {{ props.item.category.label }}
            </td>
            <td v-else></td>
            <td class="text-xs-right">
                    {{ props.item.status | projectStatus }}
            </td>
            <td class="text-xs-right">
                {{ moment(props.item.updated_at).format('L') }}
            </td>
            <td v-if="props.item.user" class="text-xs-right">
                <avatar :item="props.item.user" :tooltip="true"></avatar>
            </td>
            <td v-else></td>
        </template>

    </data-table>
</template>

<script>
import DataTable from '../../../components/DataTable'
import Avatar from '../../../components/avatar/Avatar'
import Create from './Create'
import EditStatus from './EditStatus'
import Delete from './Delete'
import moment from 'moment'
moment.locale('fr')

export default {
	components: { DataTable, Avatar },

	props: {
		filter: {
			required: false
		}
	},

	data() {
		return {
			datatable: {
				toolbar: [
					{ icon: 'delete', callback: () => { this.$eventHub.$emit('open-modal', Delete) }, level: 60 },
					{ icon: 'edit', callback: () => { this.$eventHub.$emit('open-modal', EditStatus) }, level: 60 }
				],
				actions: [
					{ text: 'Ajouter un projet', icon: 'add_circle', callback: () => { this.$eventHub.$emit('open-modal', Create) }, level: 60 }
				],
				views: [
					{ text: 'Projet en cours', link: 'projects' },
					{ text: 'Tous les projets', link: 'all-projects' },
					{ text: 'Mes projets', link: 'my-projects' },
					{ text: 'Projets archivés', link: 'archived-projects' },
				],
				headers: [
					{ text: 'Nom du projet', sortable: true,   value: 'label', align: 'left' },
					{ text: 'Super famille', sortable: true,   value: 'category.parent.parent.label', align: 'right' },
					{ text: 'Famille',       sortable: true,   value: 'category.parent.label', align: 'right' },
					{ text: 'Sous Famille',  sortable: true,   value: 'category.label', align: 'right' },
					{ text: 'Statut',        sortable: true,   value: 'status', align: 'right' },
					{ text: 'Dernère modification',        sortable: true,   value: 'updated_at', align: 'right' },
					{ text: 'Gestionnaire',  sortable: false, align: 'right' },
				],
				endpoint: {
					base: '/api/projects',
					filters: this.setFilters,
					embed: 'user,category.parent.parent,group'
				}
			},
            moment,
		}
	},

	methods: {
		rowClick(item) {
			this.$router.push({ name: 'single-project', params: { id: item.id } })
		},

		setFilters() {
			if (this.filter && this.fixed_filters) {
				this.datatable.endpoint.filters = this.fixed_filters + ',' + this.filter

			} else if (this.filter) {
				this.datatable.endpoint.filters = this.filter

			} else if (this.fixed_filters) {
				this.datatable.endpoint.filters = this.fixed_filters

			} else {
				this.datatable.endpoint.filters = ''
			}
		}
	},

	watch: {
		$route() {
			this.setFilters()
			this.$refs.list.reload()
		}
	},

	created() {
		this.$eventHub.$on('reload-list', () => {
			if (this.$refs.list) {
				this.$refs.list.reload()
			}
		})

		this.setFilters()
	}
}
</script>

<style lang="stylus" scoped>


</style>



// WEBPACK FOOTER //
// src/views/projects/list/List.vue